import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import {
  PaymentProgressChangeAction,
  PaymentProgressStatus
} from '../../../components/payment-progress/payment-progress.action';
import { Invoice } from '../../services/invoice.model';
import GlobalSpinnerService from '../../../common/services/spinner/global-spinner.service';
import { TbasService } from '../../services/tbas.services';
import { BillInfoChangeAction } from '../bill-info.action';
import UtilService from '../../../common/services/util.service';
import { Action } from '../../../common/actions/core/action';
import { BillInfoEditDialogAction } from './bill-info-edit-dialog.action';
import { ActionHandler } from '../../../common/actions/core/action-handler';
import {
  PackageThumbnail,
  ListeningPackageType
} from '../../../common/services/package/package.model';

/* @ngInject */
export default class BillInfoEditController implements ActionHandler {
  private invoice: Invoice;
  private emailValid: string;
  private selectedCity: number;
  private dialogElement;
  private packet: PackageThumbnail;

  private cities: any[];
  private towns: any[];

  constructor(
    private config,
    private $q,
    private $state,
    private globalSpinner: GlobalSpinnerService,
    private tbasService: TbasService,
    private actionDispatcher: ActionDispatcherService,
    protected $element,
    private $sanitize
  ) {}

  public $onInit() {
    if (angular.isUndefined(this.invoice)) {
      return;
    }

    this.$q.when(this.tbasService.getCityList()).then(cities => {
      this.cities = cities;
      this.selectedCity = this.getCityIdByName(this.invoice.address.city);
      this.getTowns(false);
    });

    this.emailValid = this.invoice.email;

    this.actionDispatcher.dispatch(
      new PaymentProgressChangeAction(PaymentProgressStatus.INVOICE)
    );
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#edit-invoice').remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof BillInfoEditDialogAction) {
      this.invoice = action.invoice;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
    this.$state.go('buy');
  }
  private getTowns(changed: boolean) {
    if (
      angular.isUndefined(this.invoice) ||
      angular.isUndefined(this.invoice.address)
    ) {
      this.towns = [];
    }
    this.$q
      .when(this.tbasService.getCountyList(this.selectedCity))
      .then(towns => {
        this.towns = towns;
        if (changed || angular.isUndefined(this.invoice.address.county)) {
          this.invoice.address.county = this.towns[0].name;
        }
      });
  }

  public onCityChange() {
    this.getTowns(true);
  }

  public onNext() {
    // this.invoice.address.city = this.getCityNameById(this.selectedCity);
    this.invoice.address = {};
    this.invoice.address.country = this.config.defaultCountry;
    this.invoice.address.city = 'Türkiye';
    this.invoice.address.line1 = this.invoice.email;
    this.invoice.address.postalCode = '34000';
    // invoice.identityNo=String(Math.floor(Math.random() * 100000000000));
    this.invoice.identityNo = '11111111111';
    this.invoice.firstName = UtilService.decodeHtmlCharCodes(this.$sanitize(this.invoice.firstName));
    this.invoice.lastName = UtilService.decodeHtmlCharCodes(this.$sanitize(this.invoice.lastName));
    this.invoice.email = this.$sanitize(this.invoice.email);
    this.invoice.msisdn = this.$sanitize(this.invoice.msisdn);
    this.tbasService.createInvoiceAddress(this.invoice).then(() => {
      this.actionDispatcher.dispatch(new BillInfoChangeAction(this.invoice));
      this.dialogElement.close();
      this.$state.go('buy');
    });
  }

  private getCityIdByName(name: string): number {
    for (var item of this.cities) {
      if (item.name === name) {
        return item.id;
      }
    }
    return -1;
  }

  private getCityNameById(id: number) {
    for (var item of this.cities) {
      if (item.id === id) {
        return item.name;
      }
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/bill-info/edit/bill-info-edit.controller.ts